import {Platform} from 'react-native';

// Dynamically import the correct component based on the platform
export const ImagePicker = Platform.select({
  web: require('./ImagePicker.web').default,
  //android: require('./ImagePicker.android').default,
}) as React.ComponentType;
